import { getTeamById } from '../../../actions/teams';
import { store } from '../../../index';

export function* onInviteUsers() {
  const { dispatch } = store;

  dispatch(getTeamById({}));

  yield true;
}
